import { MeetingType } from 'commons/types/meetingsTypes';

interface CGUContent {
  key: string;
  title: string;
  content: string;
}
const CGU_VALUES: Record<MeetingType, CGUContent[]> = {
  None: [],
  RDV_1: [],
  RDV_2: [
    {
      key: 'hasAcceptedCGU1',
      title: 'Respect des engagements',
      content: `
        Nous vous prions de bien vouloir honorer vos rendez-vous médicaux. Votre présence est essentielle pour assurer une bonne gestion du temps et des ressources du personnel médical. En cas d'empêchement, veuillez nous en informer dès que possible afin que nous puissions offrir ce créneau à un autre patient.
      `,
    },
    {
      key: 'hasAcceptedCGU2',
      title: 'Documents requis',
      content: `
        Veuillez vous assurer de vous munir de votre carte vitale et de votre carte d'identité à chaque rendez-vous médical. Ces documents sont nécessaires pour garantir la prise en charge de vos soins de santé et confirmer votre identité. Sans eux, il se peut que nous ne puissions pas vous recevoir.
      `,
    },
    {
      key: 'hasAcceptedCGU3',
      title: "Prévenir en cas d'empêchement",
      content: `
        En cas d'impossibilité de vous rendre à votre rendez-vous, nous vous demandons de nous prévenir au moins 24 heures à l'avance. Cela nous permettra de proposer ce créneau à un autre patient dans le besoin. Votre collaboration en matière de communication proactive est essentielle pour garantir une prise en charge efficace de tous nos patients.
      `,
    },
  ],
  RDV_3: [
    {
      key: 'hasAcceptedCGU1',
      title: 'Respect des engagements',
      content: `
        Nous vous prions de bien vouloir honorer vos rendez-vous médicaux. Les médecins du sommeil sont très demandés et vous risquez de prendre le créneau d'un autre patient en besoin.
      `,
    },
    {
      key: 'hasAcceptedCGU2',
      title: 'Equipement fonctionnel',
      content: `
        Assurez vous d'avoir un bon équipement informatique (idéalement un ordinateur, sinon un smartphone récent) et une connexion internet stable et de bonne qualité, pour tirer le meilleur de votre consultation médicale.
      `,
    },
    {
      key: 'hasAcceptedCGU3',
      title: 'Lieu calme',
      content: `
        Réalisez ce rendez-vous dans un lieu calme, propice à la discussion médicale et à l'écoute.
      `,
    },
  ],
  RDV_PPC: [
    {
      key: 'hasAcceptedCGU1',
      title: 'Respect des engagements',
      content: `
        Nous vous prions de bien vouloir honorer vos rendez-vous médicaux. Les médecins du sommeil sont très demandés et vous risquez de prendre le créneau d'un autre patient en besoin.
      `,
    },
    {
      key: 'hasAcceptedCGU2',
      title: 'Equipement fonctionnel',
      content: `
        Assurez vous d'avoir un bon équipement informatique (idéalement un ordinateur, sinon un smartphone récent) et une connexion internet stable et de bonne qualité, pour tirer le meilleur de votre consultation médicale.
      `,
    },
    {
      key: 'hasAcceptedCGU3',
      title: 'Lieu calme',
      content: `
        Réalisez ce rendez-vous dans un lieu calme, propice à la discussion médicale et à l'écoute.
      `,
    },
  ],
  RDV_SWITCH: [],
};

export default CGU_VALUES;
